import { TssVariant }                 from '@app/modules/tss/models/tss.model';
import { RequestCompleteEntityState } from '@core/interfaces/api.interface';

// ENUMS #############################################################
export enum TssLifecycleActionsEnum {
	ACTIVATE = 'activate',
	DELETE = 'delete',
	DISABLE = 'disable'
}

export enum TssLifecycleModalActionsEnum {
	ABORT = 'abort',
	CONFIRM = 'confirm',
	LIFECYCLE = 'lifecycle',
	CHECK_TSS_LOGS_NO_EXPORT_SCHEDULER_EXIST = 'checkTssLogsNoExportSchedulerExist',
	CHECK_TSS_LOGS_NOT_ACKNOWLEDGED_EXIST = 'checkTssLogsNotAcknowledgedExist',
	DESCRIPTION_STANDARD_SHOW = 'descriptionStandardShow',
	DESCRIPTION_PUK_SHOW = 'descriptionPukShow',
	DESCRIPTION_TSS_LOGS_NOT_ACKNOWLEDGED_EXIST_SHOW = 'descriptionTssLogsNotAcknowledgedExistShow',
	DESCRIPTION_TSS_LOGS_NO_EXPORT_SCHEDULER_SHOW = 'descriptionTssLogsNoExportSchedulerShow',
	FORM_SHOW = 'formShow',
	FORM_SUBMIT = 'formSubmit',
	NAVIGATE_TO_FISKAL_TSS_LOGS = 'navigateToFiskalTssLogs',
	OVERLAY_WARNING_STANDARD_HIDE = 'overlayWarningStandardHide',
	OVERLAY_WARNING_STANDARD_SHOW = 'overlayWarningStandardShow',
}

// INTERFACES ########################################################
export interface ITssLifecycleModalAbortResult {
	action: TssLifecycleModalActionsEnum.ABORT;
}

export interface ITssLifecycleModalLifecycleResult {
	action: TssLifecycleModalActionsEnum.LIFECYCLE;
	lifecycle: TssLifecycleActionsEnum;
	requestCompleteState: RequestCompleteEntityState<TssVariant>;
	tss: TssVariant;
}

export interface ITssLifecycleModalNavigateToFiskalTssLogsResult {
	action: TssLifecycleModalActionsEnum.NAVIGATE_TO_FISKAL_TSS_LOGS;
	tss: TssVariant;
}

// TYPES #############################################################
export type TssLifecycleModalResultType =
	ITssLifecycleModalAbortResult
	| ITssLifecycleModalLifecycleResult
	| ITssLifecycleModalNavigateToFiskalTssLogsResult;

// ENTITIES ##########################################################

